import React from "react";
import ReactSwitch from "react-switch";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { SketchPicker } from "react-color";

import {
    templateActions,
    templateStore,
} from "@pages/Applications/C&C/C&CSetup/templateStore";

import { ColorSvgIcon } from "@components/Common/SvgIcons";
import LanguageTable from "../../../Common/LanguageTable";
import { templateDefaultValue } from "@constants/template";
import BannerImages from "../../../Common/BannerImages";

export function Section4() {
    const { t } = useTranslation();
    const sketchPickerRef = React.useRef<HTMLDivElement>(null);
    const { template } = useSnapshot(templateStore);

    const [activateButton, setActiveButton] = React.useState<boolean>(
        template.SiteWeb.LaindingPage.Section4.Activer ?? false
    );
    const [color, setColor] = React.useState<any>(
        template.SiteWeb.LaindingPage.Section4.Color ?? "black"
    );
    const [playStore, setPlayStore] = React.useState<any>(
        template?.SiteWeb?.LaindingPage?.Section4?.PlayeStore?.Url ?? ""
    );
    const [appStore, setAppStore] = React.useState<any>(
        template?.SiteWeb?.LaindingPage?.Section4?.AppStore?.Url ?? ""
    );
    const [playStoreState, setPlayStoreState] = React.useState<any>(
        template?.SiteWeb?.LaindingPage?.Section4?.PlayeStore?.Activer ?? false
    );
    const [appStoreState, setAppStoreState] = React.useState<any>(
        template?.SiteWeb?.LaindingPage?.Section4?.AppStore?.Activer ?? false
    );
    const [colorMainPicker, setColorMainPicker] = React.useState(false);
    const imagePath = React.useMemo(
        () => ["SiteWeb", "LaindingPage", "Section4", "Image"],
        []
    );
    const handleChangeColor = () => {
        setColorMainPicker(!colorMainPicker);
    };
    const handleUpdate = (item: string, activation: boolean, value: any) => {
        templateActions.updateTemplate(
            [
                "template",
                "SiteWeb",
                "LaindingPage",
                "Section4",
                item,
                activation ? "Activer" : "Url",
            ],
            value
        );
    };
    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                sketchPickerRef.current &&
                !sketchPickerRef.current.contains(event.target as Node)
            ) {
                setColorMainPicker(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="banner-container">
            <section className="text-section">
                <div className=" d-flex justify-content-between p-2 pr-4 pt-3">
                    <span
                        style={{
                            top: "630px",
                            left: "321px",
                            width: "153px",
                            height: "21px",
                            textAlign: "left",
                            font: "normal normal 600 16px/21px Segoe UI",
                            letterSpacing: "0px",
                            color: "#000000",
                            opacity: "1",
                        }}
                    >
                        {t("Images")}
                    </span>
                    <ReactSwitch
                        className="cac_icn_quickConnection"
                        offColor="#faafb4"
                        offHandleColor="#E30613"
                        onColor="#c2eec4"
                        onHandleColor="#34C38F"
                        height={19}
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        checked={activateButton}
                        onChange={(e: any) => {
                            setActiveButton(!activateButton);
                            templateActions.updateTemplate(
                                [
                                    "template",
                                    "SiteWeb",
                                    "LaindingPage",
                                    "Section4",
                                    "Activer",
                                ],
                                !activateButton
                            );
                        }}
                    />
                </div>
                <div className="banner-images" style={{ paddingRight: "20px" }}>
                    <BannerImages
                        dataPath={imagePath}
                        title="Image"
                        size="597*500 (png,jpg,jpeg ou webp)"
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <span
                        style={{ pointerEvents: "none", cursor: "default" }}
                        className="ml-3 mr-5"
                    >
                        {t("Main color")}
                    </span>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "20px",
                        }}
                    >
                        <div
                            style={{
                                borderRadius: 3,
                                width: 160,
                                height: 20,
                                backgroundColor: color,
                                marginRight: 10,
                            }}
                        ></div>
                        <span
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            <ColorSvgIcon
                                onClick={handleChangeColor}
                                height="20"
                                width="20"
                                color={color}
                            />
                            {colorMainPicker ? (
                                <div
                                    tabIndex={0}
                                    style={{
                                        position: "fixed",
                                        top: "30%",
                                        right: "67%",
                                        zIndex: 2,
                                    }}
                                    ref={sketchPickerRef}
                                >
                                    <SketchPicker
                                        color={color}
                                        onChange={(color) => {
                                            setColor(color.hex);
                                            templateActions.updateTemplate(
                                                [
                                                    "template",
                                                    "SiteWeb",
                                                    "LaindingPage",
                                                    "Section4",
                                                    "Color",
                                                ],
                                                color.hex
                                            );
                                        }}
                                    />
                                </div>
                            ) : null}
                        </span>
                    </div>
                </div>
                <LanguageTable
                    path={["SiteWeb", "LaindingPage", "Section4"]}
                    fields={[
                        {
                            key: "Title",
                            label: "Title",
                            placeholder: "Enter the Title",
                        },
                        {
                            key: "Description",
                            label: "Description",
                            placeholder: "Enter the Description",
                        },
                    ]}
                    defaultTexts={
                        templateDefaultValue.SiteWeb.LaindingPage.Section4
                    }
                    sectionTitle="Title and Description"
                />{" "}
                <div
                    style={{
                        padding: "10px  15px 10px 10px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "2%",
                        }}
                    >
                        <span
                            style={{ pointerEvents: "none", cursor: "default" }}
                            className="ml-3 mr-3"
                        >
                            {t("PlayStore")}
                        </span>
                        <input
                            type="text"
                            className="form-control epb_inp_timeAS mr-2"
                            onChange={(e: any) => {
                                setPlayStore(e.target.value);
                                handleUpdate(
                                    "PlayeStore",
                                    false,
                                    e.target.value
                                );
                            }}
                            value={playStore}
                            min={1}
                        />
                        <ReactSwitch
                            className="cac_icn_quickConnection"
                            offColor="#faafb4"
                            offHandleColor="#E30613"
                            onColor="#c2eec4"
                            onHandleColor="#34C38F"
                            height={19}
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checked={playStoreState}
                            onChange={(e: any) => {
                                setPlayStoreState(!playStoreState);
                                handleUpdate(
                                    "PlayeStore",
                                    true,
                                    !playStoreState
                                );
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "2%",
                        }}
                    >
                        <span
                            style={{ pointerEvents: "none", cursor: "default" }}
                            className="ml-3 mr-3"
                        >
                            {t("AppStore")}
                        </span>
                        <input
                            type="text"
                            className="form-control epb_inp_timeAS mr-2"
                            onChange={(e: any) => {
                                setAppStore(e.target.value);
                                handleUpdate("AppStore", false, e.target.value);
                            }}
                            value={appStore}
                            min={1}
                        />
                        <ReactSwitch
                            className="cac_icn_quickConnection"
                            offColor="#faafb4"
                            offHandleColor="#E30613"
                            onColor="#c2eec4"
                            onHandleColor="#34C38F"
                            height={19}
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checked={appStoreState}
                            onChange={(e: any) => {
                                setAppStoreState(!appStoreState);
                                handleUpdate("AppStore", true, !appStoreState);
                            }}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}
